import { mapState, mapActions, mapMutations, mapGetters } from "vuex"

import io from "socket.io-client"

import height_expand from "~/components/transitions/heightExpand"
import notification_display from "~/components/notificationDisplay"

import snackbar_notification_mixin from "~/components/notificationSpace/snackbar.js"

export default {
  mixins: [snackbar_notification_mixin],
  components: {
    height_expand,
    notification_display,
  },
  data: function () {
    return {
      unsubscribe_handler: function () {},
      connected: false,
      expand_notif: false,
      socket: null,
    }
  },
  mounted: function () {
    if (this.is_logged_in && process.client) this.init()
    this.unsubscribe_handler = this.$store.subscribe((mutation) => {
      if (mutation.type === "user/band/SET" && mutation.payload > 0)
        this.getNotifByBand()
    })
    this.fetchLastReads()
  },
  beforeDestroy: function () {
    this.unsubscribe_handler()
  },
  computed: {
    shouldDisplayDot: function () {
      if (this.sortedList.length)
        return this.last_seen !== this.sortedList[0].id
      return false
    },
    unseen_count: function () {
      var count = 0

      for (var i = this.sortedList.length - 1; i >= 0; i--) {
        if (!this.sortedList[i].datetime_seen) count++
      }
      return count
    },
    sortedList: function () {
      const copy = [...this.notifications]

      copy.sort((a, b) => {
        return b.id - a.id
      })
      return copy
    },
    ...mapState({
      notifications: (state) => state.notification.list,
      selectedBand: (state) => state.user.band.id,
    }),
    ...mapGetters({
      is_logged_in: "user/IS_LOGGED_IN",
      last_seen: "notification/SELECTED_LAST_SEEN",
    }),
  },
  methods: {
    init: async function () {
      const token = await this.$axios.$get("/auth/token/message/")
      const socket = io(`${window.location.origin}/notification/`, {
        path: "/message/connect/",
        query: { token },
      })

      if (this.socket !== null) this.socket.disconnect()
      socket.on(
        "connect",
        function () {
          this.connected = true
          socket.on(
            "notification",
            function (data) {
              this.add_notification(data)
            }.bind(this)
          )
          this.fetch()
        }.bind(this)
      )
      this.socket = socket
    },
    fetch: async function () {
      this.getNotifByBand()
    },
    add_notification: function (new_notification) {
      let newNotif = this.$store.dispatch("notification/ADD", new_notification)

      if (newNotif) {
        this.createSnackbar(new_notification)
        this.update_last_seen({
          id: this.selectedBand,
          value: 0,
        })
      }
    },
    closeExpandNotif: function () {
      this.expand_notif = false
    },
    bellClicked: function () {
      if (this.sortedList.length) {
        this.update_last_seen({
          id: this.selectedBand,
          value: this.sortedList[0].id,
        })
      }
    },
    markAsSeen: function (ids) {
      if (typeof ids !== "object") ids = [ids]
      this.emit_markAsSeen(ids)
    },
    ...mapActions({
      emit_markAsSeen: "notification/MARK_AS_SEEN",
      markAllAsSeen: "notification/MARK_ALL_AS_SEEN",
      fetchLastReads: "notification/FETCH_LAST_READS",
      getNotifByBand: "notification/GET_NOTIFICATIONS_BY_BAND",
    }),
    ...mapMutations({
      update_last_seen: "notification/SET_LAST_READ",
    }),
  },
  watch: {
    selectedBand: "init",
  },
}
